import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Card, H2, Separator, Text } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { EnvelopeAccountCryptoRecommendationDocument } from './graphql/envelopeAccountCryptoRecommendation.generated';

export const CryptoAssetsRecommendationCardView: React.FC = () => {
  const accountId = useRequiredParam('accountId');

  const { data } = useGraphQLQuery(EnvelopeAccountCryptoRecommendationDocument, {
    variables: { id: accountId },
    throwOnError: true,
  });

  if (!data) return <CardLoader />;

  if (data.account && data.account.__typename === 'ManagedAccount') {
    const { account } = data;
    const { cryptoAssetsRecommendation } = account;

    if (!cryptoAssetsRecommendation) return null;

    return (
      <Card>
        <Card.Header>
          <H2 variant="title200" css={{ padding: 'space.300' }}>
            Advice
          </H2>
        </Card.Header>
        <Separator css={{ fullWidthWithInset: 'space.300' }} />
        <Card.Content
          css={{
            padding: 'space.300',
          }}
        >
          <Text dangerouslySetInnerHTML={{ __html: cryptoAssetsRecommendation }} />
        </Card.Content>
      </Card>
    );
  }

  return null;
};

export const CryptoAssetsRecommendationCard: React.FC = () => (
  <ErrorBoundary fallbackType="none">
    <CryptoAssetsRecommendationCardView />
  </ErrorBoundary>
);
